// extracted by mini-css-extract-plugin
export default {"modalCard":"IlomePdfModal_modalCard__Bxcit","closeButton":"IlomePdfModal_closeButton__eeRBK","modalBody":"IlomePdfModal_modalBody__7cNd1","pdfFrame":"IlomePdfModal_pdfFrame__lsg7N"};